import Behaviour from "../../lib/ui/Behaviour";
import { Log } from "../../lib/util/Log";
var log = Log.log;
/**
 * {@link ClueSolvingSubBehaviour}s implement active components for the {@link ClueSolvingBehaviour}.
 * They are instantiated when a clue of the respective type is solved.
 * Subbehaviours typically instantiate internal reading processes, for example for active puzzles, and self-terminate if the step is completed.
 */
export class ClueSolvingSubBehaviour extends Behaviour {
    constructor(name, parent, type) {
        super();
        this.name = name;
        this.parent = parent;
        this.type = type;
        this._state = undefined;
    }
    setRelatedState(state) {
        this._state = state;
    }
    endClue(reason) {
        if (this.parent?.reset(this._state)) {
            log().log(`Ended clue from subbehaviour: ${reason}`, "NeoSolving");
        }
        this.stop();
    }
    registerSolution(area) {
        if (!this._state) {
            console.error("Setting solution area with undefined state");
            debugger;
        }
        this.parent.setSolutionArea(this._state, area);
    }
    /**
     * Determines whether auto-solving is paused while this subbehaviour is active.
     * Checked on every tick of the AutoSolving process, so it can be dynamically checked based on internal state.
     */
    pausesClueReader() {
        return false;
    }
}
